require.context('bender-url!../img', true);
import { clearHsLocale } from 'hs-locale-management';
import './detectFramed';
// @ts-ignore ts-migrate(7016) FIXME: Could not find a declaration file for module './Ap... Remove this comment to see the full error message
import Application from './App';
clearHsLocale();
new Application().start();